export default "__VITE_ASSET__5ece514a__"